
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

/**
 * Fetches counties marked as 'featured' from the counties table.
 * Returns name, slug, image_url, nursing_home_count, description, display_order
 */
export function useFeaturedCounties() {
  return useQuery({
    queryKey: ["featured-counties"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("counties")
        .select(
          "id, name, slug, image_url, nursing_home_count, description, display_order"
        )
        .eq("featured", true)
        .order("display_order", { ascending: true });

      if (error) {
        console.error("Error fetching featured counties:", error);
        throw new Error("Failed to fetch featured counties");
      }

      // Log the featured counties and their image URLs for debugging
      data?.forEach(county => {
        console.log(`Featured county ${county.name}, image URL: ${county.image_url}`);
      });

      return data || [];
    },
  });
}
